import React, { useEffect, useState, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from 'shared/utils/Interceptor';
import * as XLSX from 'xlsx';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import CustomSelect from 'shared/components/common/custom_selection/CustomSelection';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import { GetAllCategoryQuery } from 'shared/services/category_service/CategoryService';
import { GetAllSubCategoryQuery } from 'shared/services/sub_category_service/SubCategoryService';
import { GetAllProductQuery } from 'shared/services/product_service/ProductService';
import { GetAllBrandQuery } from 'shared/services/brand_service/BrandService';
import { useFormik } from 'formik';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import { PoVS } from 'shared/utils/validation/AuthValidation';
import { AddPOMutation, GetAllPOQuery } from 'shared/services/po_service/POService';
import { useNavigate } from 'react-router-dom';
import { routeConstant } from 'shared/routes/RouteConstant';
import Select from 'react-select';
import InnerPoTable from './InnerPoTable';
import PurchaseOrderSuplierModal from 'shared/modal/purchase_order_supplier/PurchaseOrderSupplier';
import { isRestrictActions } from 'shared/utils/Helper';
import { screenActionEnum, screenEnum } from 'shared/utils/Enum';
import UploadAvatar from 'shared/components/common/upload_avatar/UploadAvatar';
import { uploadFileMedia } from 'shared/services/media_service/Media_Service';
import UploadAvatarArray from 'shared/components/common/upload_avatar/UploadAvatarArray';
import { GetAllCompetibleBrandQuery } from 'shared/services/competible_brand_service/CompetibleBrandService';
import { GetAllColors } from 'shared/services/color_services/ColorsServices';
import { toast } from 'react-toastify';
import AddBrand from 'shared/modal/add_brand/AddBrand';
import AddCompetibleBrand from 'shared/modal/add_competible_brand/AddCompetibleBrand';
import AddCategory from 'shared/modal/add_category/AddCategory';
import AddSubCategory from 'shared/modal/add_sub_category/AddSubCategory';
import AddColors from 'shared/modal/add_color/AddColors';
import AddProduct from 'shared/modal/add_product/AddProduct';
import { GetAllWarehouse } from 'shared/services/ware_house_service/WareHouseService';

export default function PurchaseOrderModal({ show, handleClose, isEdit = false }) {
    const { mutate: addPOMutation, isLoading: POLoading, isSuccess: ProductIsSuccess } = AddPOMutation();
    const navigate = useNavigate();
    const { data: listCategory } = GetAllCategoryQuery();
    const { data: listSubCategory } = GetAllSubCategoryQuery();
    const { data: listProduct } = GetAllProductQuery();
    const { data: listBrnd } = GetAllBrandQuery();
    const { data: listCompetebleBrnd } = GetAllCompetibleBrandQuery();
    const { data: colorlist } = GetAllColors();
    const { data: PoList } = GetAllPOQuery();




    const [avatarFile, setAvatarFile] = useState(null);
    const [selectedImg, setSelectedImg] = useState('');
    const [avatarFileArray, setAvatarFileArray] = useState([]);
    const [colorarray, setarraycolor] = useState([]);
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    const [ModelList, setModelList] = useState([]);
    const [CatList, setCatList] = useState(listCategory);
    const [SubCatlList, setSubCatList] = useState([]);
    const [currencyList, setCurrencyList] = useState('');
    const [isEdits, setIsEdit] = useState(true);
    const [PoListing, setPoListing] = useState(() => {
        const stored = sessionStorage.getItem('temp_po_listing_order');
        return stored ? JSON.parse(stored) : [];
    });
    const [SupplierVal, setSupplierVal] = useState('');
    const [modalShow, setShowModal] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [isProcessingExcel, setIsProcessingExcel] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showBrandModal, setShowBrandModal] = useState(false);
    const [showCompatibleBrandModal, setShowCompatibleBrandModal] = useState(false);
    const [showModelModal, setShowModelModal] = useState(false);
    const [showCatModal, setShowCatModal] = useState(false);
    const [showSubCatModal, setShowSubCatModal] = useState(false);
    const [showColorModal, setShowColorModal] = useState(false);
    const closeProductHandler = () => {

        setShowBrandModal(false);
        setShowCompatibleBrandModal(false);
        setShowCatModal(false);
        setShowSubCatModal(false);
        setShowColorModal(false);
        setShowModelModal(false);
    }

    const [newlyAddedItem, setNewlyAddedItem] = useState({ type: null, value: null });

    const handleSuccessAdd = (type, value) => {
        setNewlyAddedItem({ type, value });
    };

    useEffect(() => {
        if (!colorlist || colorlist.length === 0) {
            setarraycolor([]); // ✅ Clear color array if no data
            return;
        }

        const mapped = colorlist.map(ii => ({
            ...ii,
            label: ii?.color || '',
            value: ii?.color || '',
        }));

        setarraycolor(mapped);
    }, [colorlist]);

    const skuOptions = React.useMemo(() => {
        if (!PoList) return [];
        const seenSkus = new Set();
        const options = [];
        
        PoList.forEach(po => {
            po.order?.forEach(orderItem => {
                if (orderItem?.sku && !seenSkus.has(orderItem.sku)) {
                    seenSkus.add(orderItem.sku);
                    const parts = [
                        orderItem.sku,
                        orderItem.brand?.name,
                        orderItem.compatiableBrand?.name,
                        orderItem.product?.name,
                        orderItem.product_category?.name,
                        orderItem.sub_category?.name,
                        orderItem.color
                    ].filter(Boolean);

                    options.push({
                        label: parts.join(' - '),
                        value: orderItem.product?._id,
                        fullData: orderItem
                    });
                }
            });
        });
        return options;
    }, [PoList]);




    console.log(showBrandModal, "showBrandModal");

    const initialValues = {
        model: '',
        brand: '',
        competebleBrand: '',
        ProductCategory: '',
        SubCategory: '',
        price: '',
        currency: '',
        quantity: '',
        description: '',
        color: ''

    };

    const customFilter = (option, inputValue) => {
        if (!inputValue) return true;
        
        const searchTerms = inputValue.toLowerCase().split(' ').filter(term => term.length > 0);
        const data = option.data?.fullData || {};
        
        // Build a searchable string of all relevant matching fields
        const searchableText = `
            ${option.label || ""} 
            ${data.brand?.name || ""} 
            ${data.compatiableBrand?.name || ""} 
            ${data.product?.name || ""} 
            ${data.product_category?.name || ""} 
            ${data.sub_category?.name || ""} 
            ${data.color || ""}
        `.toLowerCase();
        
        // Ensure ALL search terms from user input are found in the searchable text
        return searchTerms.every(term => searchableText.includes(term));
    };

    // ─── Draft Form Fields Persistence (5s restore window, isolated per page) ──────
    const PO_DRAFT_FORM_KEY = 'temp_po_draft_form_fields';
    const RL_DRAFT_FORM_KEY = 'temp_rl_draft_form_fields'; // to cross-clear
    const PO_DRAFT_RESTORE_MS = 5000; // 5 seconds
    const draftRestoredRef = useRef(false);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: PoVS,
        onSubmit: (values) => {
            let newItem = {
                product: values.model,
                brand: values.brand,
                competebleBrand: values.competebleBrand,
                product_category: values.ProductCategory,
                sub_category: values.SubCategory,
                quantity: values.quantity,
                price: values.price,
                currency: values.currency,
                description: values.description,
                color: values.color.label
            };

            newItem['raw_images'] = avatarFileArray;

            // Check for duplicates
            const isDuplicate = PoListing.some(item =>
                item.product?._id === newItem.product?._id &&
                item.brand?._id === newItem.brand?._id &&
                item.competebleBrand?._id === newItem.competebleBrand?._id &&
                item.product_category?._id === newItem.product_category?._id &&
                item.sub_category?._id === newItem.sub_category?._id &&
                item.color === newItem.color
            );

            if (isDuplicate) {
                toast.error("This item already exists in the PO list.");
                return; // Prevent adding duplicate
            }

            // Add new item
            const updatedList = [...PoListing, newItem];
            setPoListing(updatedList);

            // Clear the draft form fields once item is added
            sessionStorage.removeItem(PO_DRAFT_FORM_KEY);
            draftRestoredRef.current = false;

            // Reset form states
            setIsEdit(true);
            // formik.resetForm();
            setAvatarFileArray([]);
        }

    });
    const { handleChange, setFieldValue, handleSubmit, values, touched, errors } = formik;

    // On mount: cross-clear RL draft, then restore PO draft if within 5s
    useEffect(() => {
        // Always clear the OTHER page's draft to prevent cross-contamination
        sessionStorage.removeItem(RL_DRAFT_FORM_KEY);

        if (draftRestoredRef.current) return;
        try {
            const raw = sessionStorage.getItem(PO_DRAFT_FORM_KEY);
            if (!raw) return;
            const { values: saved, timestamp } = JSON.parse(raw);
            const ageMs = Date.now() - timestamp;
            if (ageMs <= PO_DRAFT_RESTORE_MS && saved) {
                Object.keys(saved).forEach(key => {
                    if (saved[key] !== '' && saved[key] !== null && saved[key] !== undefined) {
                        formik.setFieldValue(key, saved[key]);
                    }
                });
                draftRestoredRef.current = true;
            } else {
                // Expired — remove stale draft
                sessionStorage.removeItem(PO_DRAFT_FORM_KEY);
            }
        } catch (_) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Save form values to sessionStorage whenever a meaningful field is filled
    useEffect(() => {
        const hasMeaningfulValue = (
            (values.brand && (values.brand._id || values.brand.label)) ||
            (values.competebleBrand && (values.competebleBrand._id || values.competebleBrand.label)) ||
            (values.model && (values.model._id || values.model.label)) ||
            (values.ProductCategory && (values.ProductCategory._id || values.ProductCategory.label)) ||
            (values.SubCategory && (values.SubCategory._id || values.SubCategory.label)) ||
            (values.color && (values.color._id || values.color.label)) ||
            (values.price && values.price !== '') ||
            (values.quantity && values.quantity !== '') ||
            (values.description && values.description !== '')
        );
        if (hasMeaningfulValue) {
            sessionStorage.setItem(PO_DRAFT_FORM_KEY, JSON.stringify({ values, timestamp: Date.now() }));
        }
    }, [values]);

    useEffect(() => {
        listCategory?.map((ii) => {
            ii['label'] = ii?.name;
            ii['value'] = ii?.name;
            return ii;
        });
        listProduct?.map((ii) => {
            ii['label'] = ii?.name;
            ii['value'] = ii?.name;
            return ii;
        });
        listSubCategory?.map((ii) => {
            ii['label'] = ii?.name;
            ii['value'] = ii?.name;
            return ii;
        });
        listBrnd?.map((ii) => {
            ii['label'] = ii?.name;
            ii['value'] = ii?.name;
            return ii;
        });
        listCompetebleBrnd?.map((ii) => {
            ii['label'] = ii?.name;
            ii['value'] = ii?.name;
            return ii;
        });


    }, [listCategory, listSubCategory, listProduct, listBrnd, listCompetebleBrnd,]);

    // Keep SubCatList updated when listSubCategory updates (after adding new sub category)
    useEffect(() => {
        if (values.ProductCategory && values.ProductCategory._id) {
            setSubCatList(listSubCategory?.filter((ii) => values.ProductCategory._id === ii?.category?._id) || []);
        } else {
            setSubCatList([]);
        }
    }, [listSubCategory, values.ProductCategory]);

    // Keep ModelList updated when listProduct updates (after adding new model)
    useEffect(() => {
        if (values.competebleBrand && values.competebleBrand._id) {
            setModelList(listProduct?.filter((ii) => values.competebleBrand._id === ii?.compatiableBrand?._id) || []);
        } else {
            setModelList([]);
        }
    }, [listProduct, values.competebleBrand]);


    // Auto-select newly added item once it's available in the list
    useEffect(() => {
        if (!newlyAddedItem.type || !newlyAddedItem.value) return;

        const { type, value } = newlyAddedItem;
        const lowercaseValue = value.trim().toLowerCase();

        if (type === 'brand' && listBrnd) {
            const found = listBrnd.find(item => item?.name?.trim().toLowerCase() === lowercaseValue);
            if (found) {
                setFieldValue('brand', Object.assign({}, found, { label: found.name, value: found.name }));
                setNewlyAddedItem({ type: null, value: null });
            }
        } else if (type === 'competebleBrand' && listCompetebleBrnd) {
            const found = listCompetebleBrnd.find(item => item?.name?.trim().toLowerCase() === lowercaseValue);
            if (found) {
                setFieldValue('competebleBrand', Object.assign({}, found, { label: found.name, value: found.name }));
                setNewlyAddedItem({ type: null, value: null });
            }
        } else if (type === 'category' && listCategory) {
            const found = listCategory.find(item => item?.name?.trim().toLowerCase() === lowercaseValue);
            if (found) {
                setFieldValue('ProductCategory', Object.assign({}, found, { label: found.name, value: found.name }));
                setNewlyAddedItem({ type: null, value: null });
            }
        } else if (type === 'subCategory' && SubCatlList) { // Use filtered SubCatlList
            const found = SubCatlList.find(item => item?.name?.trim().toLowerCase() === lowercaseValue);
            if (found) {
                setFieldValue('SubCategory', Object.assign({}, found, { label: found.name, value: found.name }));
                setNewlyAddedItem({ type: null, value: null });
            }
        } else if (type === 'model' && ModelList) { // Use filtered ModelList
            const found = ModelList.find(item => item?.name?.trim().toLowerCase() === lowercaseValue);
            if (found) {
                setFieldValue('model', Object.assign({}, found, { label: found.name, value: found.name }));
                setNewlyAddedItem({ type: null, value: null });
            }
        } else if (type === 'color' && colorarray) {
            const found = colorarray.find(item => item?.color?.trim().toLowerCase() === lowercaseValue);
            if (found) {
                setFieldValue('color', Object.assign({}, found, { label: found.color, value: found.color }));
                setNewlyAddedItem({ type: null, value: null });
            }
        }
    }, [listBrnd, listCompetebleBrnd, listCategory, SubCatlList, ModelList, colorarray, newlyAddedItem, setFieldValue]);

    const customAddBrandOption = {
        label: "+ Add New",
        value: "__add_new__"
    };

    const brandOptions = [
        customAddBrandOption,
        ...(Array.isArray(listBrnd) ? listBrnd : [])
    ];
    const listCompetebleBrndOptions = [
        customAddBrandOption,
        ...(Array.isArray(listCompetebleBrnd) ? listCompetebleBrnd : [])
    ];
    const ModelListOptions = [
        customAddBrandOption,
        ...(Array.isArray(ModelList) ? ModelList : [])
    ];
    const SubCatlListOptions = [
        customAddBrandOption,
        ...(Array.isArray(SubCatlList) ? SubCatlList : [])
    ];
    const listCategoryOptions = [
        customAddBrandOption,
        ...(Array.isArray(listCategory) ? listCategory : [])
    ];
    const colorarrayOptions = [
        customAddBrandOption,
        ...(Array.isArray(colorarray) ? colorarray : [])
    ];
    const SubmmitPo = async (suplierObj) => {
        let obj = {
            order: [],
            supplier: suplierObj.supplier,
            description: ''
        };


        PoListing.map((item) => {
            const isScreenProtector = String(item.product_category?.name || "").toLowerCase() === "screen protector";

            // Decide color value
            let colorValue = item.color;
            if (isScreenProtector) {
                // Ignore color for Screen Protector, make it "Transparent" if blank
                colorValue = "Transparent";
            }
            obj.order.push({
                product: item.product?._id,
                product_category: item.product_category?._id,
                compatiableBrand: item.competebleBrand?._id,
                sub_category: item.sub_category?._id,
                brand: item.brand?._id,
                quantity: item.quantity,
                price: item.price,
                // currency: item.currency,
                color: colorValue,
                raw_images: item.raw_images,
                product_category_name: item.product_category.name

            });
            obj.supplier = suplierObj.supplier;
            obj.description = item.description;
            obj.whareHouse = suplierObj.others;

        });
        // obj.supplier = suplierVal;
        console.log(suplierObj, 'suplierObj')
        addPOMutation(obj);
    };
    useEffect(() => {
        if (PoListing && PoListing.length > 0) {
            sessionStorage.setItem('temp_po_listing_order', JSON.stringify(PoListing));
        } else {
            sessionStorage.removeItem('temp_po_listing_order');
        }
    }, [PoListing]);

    useEffect(() => {
        if (ProductIsSuccess) {
            sessionStorage.removeItem('temp_po_listing_order');
            navigate(routeConstant.admin.po.list.path);
        }
    }, [ProductIsSuccess]);


    const uploadMediaArray = async (files) => {
        try {
            setUploading(true);
            setUploadProgress(0);

            let cloneAvatarFile = [...avatarFileArray];
            let total = files.length;
            let done = 0;

            for (let file of files) {
                let fileBody = new FormData();
                fileBody.append("image", file);
                const imgfileArray = await uploadFileMedia(fileBody);
                const newurl = imgfileArray.data.url;
                cloneAvatarFile.push(newurl);

                done++;
                setUploadProgress(Math.round((done / total) * 100));
            }

            setAvatarFileArray(cloneAvatarFile);
        } catch (error) {
            console.error("Upload error:", error);
        } finally {
            setUploading(false);
        }
    };

    const fileInputRef = useRef(null);

    const downloadSampleExcel = () => {
        const sampleData = [
            {
                Brand: "Apple",
                "Compatible Brand": "Apple",
                Category: "LCD",
                "Sub Category": "Incell",
                Model: "iPhone 11",
                Color: "Black",
                Quantity: 10,
                Price: 15.5,
                Description: "Sample description"
            }
        ];
        const worksheet = XLSX.utils.json_to_sheet(sampleData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sample PO");
        XLSX.writeFile(workbook, "PO_Sample_Format.xlsx");
    };

    const handleExcelUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setIsProcessingExcel(true);
        const reader = new FileReader();
        reader.onload = async (evt) => {
            try {
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: 'binary' });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = XLSX.utils.sheet_to_json(ws);

                let newItems = [];
                let errors = [];

                let localBrands = [...(listBrnd || [])];
                let localCompBrands = [...(listCompetebleBrnd || [])];
                let localCategories = [...(listCategory || [])];
                let localSubCategories = [...(listSubCategory || [])];
                let localProducts = [...(listProduct || [])];
                let localColors = [...(colorarray || [])];

                for (let i = 0; i < data.length; i++) {
                    const row = data[i];
                    const rowIndex = i + 2;
                    
                    const brandName = row["Brand"]?.toString().trim();
                    const compBrandName = row["Compatible Brand"]?.toString().trim();
                    const catName = row["Category"]?.toString().trim();
                    const subCatName = row["Sub Category"]?.toString().trim();
                    const modelName = row["Model"]?.toString().trim();
                    const colorName = row["Color"]?.toString().trim();

                    if (!brandName || !compBrandName || !catName || !subCatName || !modelName || !colorName) {
                        errors.push(`Row ${rowIndex}: Missing required fields.`);
                        continue;
                    }

                    try {
                        let brand = localBrands.find(b => b.name?.toLowerCase() === brandName.toLowerCase());
                        if (!brand) {
                            const res = await HTTP_CLIENT.post(Endpiont.brand.add, { name: brandName });
                            brand = res.data?.data || res.data; 
                            localBrands.push(brand);
                        }

                        let competebleBrand = localCompBrands.find(b => b.name?.toLowerCase() === compBrandName.toLowerCase());
                        if (!competebleBrand) {
                            const res = await HTTP_CLIENT.post(Endpiont.competibleBrand.add, { name: compBrandName });
                            competebleBrand = res.data?.data || res.data;
                            localCompBrands.push(competebleBrand);
                        }

                        let product_category = localCategories.find(c => c.name?.toLowerCase() === catName.toLowerCase());
                        if (!product_category) {
                            const res = await HTTP_CLIENT.post(Endpiont.category.add, { name: catName });
                            product_category = res.data?.data || res.data;
                            localCategories.push(product_category);
                        }

                        let sub_category = localSubCategories.find(s => s.name?.toLowerCase() === subCatName.toLowerCase() && s.category?._id === product_category._id);
                        if (!sub_category) {
                            const res = await HTTP_CLIENT.post(Endpiont.subCategory.add, { name: subCatName, category: product_category._id, point: 0 });
                            sub_category = res.data?.data || res.data;
                            if (!sub_category.category) sub_category.category = product_category;
                            localSubCategories.push(sub_category);
                        }

                        let product = localProducts.find(p => p.name?.toLowerCase() === modelName.toLowerCase() && p.compatiableBrand?._id === competebleBrand._id);
                        if (!product) {
                            const res = await HTTP_CLIENT.post(Endpiont.product.add, { name: modelName, compatiableBrand: competebleBrand._id });
                            product = res.data?.data || res.data;
                            if (!product.compatiableBrand) product.compatiableBrand = competebleBrand;
                            localProducts.push(product);
                        }

                        let colorObj = localColors.find(c => c.color?.toLowerCase() === colorName.toLowerCase());
                        if (!colorObj) {
                            const res = await HTTP_CLIENT.post(Endpiont.color.add, { color: colorName });
                            colorObj = res.data?.data || res.data;
                            localColors.push(colorObj);
                        }

                        newItems.push({
                            product: Object.assign({}, product, { label: product.name || product.model, value: product.name || product.model }),
                            brand: Object.assign({}, brand, { label: brand.name, value: brand.name }),
                            competebleBrand: Object.assign({}, competebleBrand, { label: competebleBrand.name, value: competebleBrand.name }),
                            product_category: Object.assign({}, product_category, { label: product_category.name, value: product_category.name }),
                            sub_category: Object.assign({}, sub_category, { label: sub_category.name, value: sub_category.name }),
                            quantity: row["Quantity"] || 1,
                            price: row["Price"] || 0,
                            description: row["Description"] || "",
                            color: colorObj.color,
                            raw_images: []
                        });

                    } catch (err) {
                        console.error(`Error processing row ${rowIndex}:`, err);
                        errors.push(`Row ${rowIndex}: Failed to create missing item. Error: ${err.message}`);
                    }
                }

                if (errors.length > 0) {
                    toast.error(`Some rows had errors:\n${errors.join('\n')}`);
                }

                if (newItems.length > 0) {
                    setPoListing(prev => [...prev, ...newItems]);
                    toast.success(`${newItems.length} items added successfully!`);
                }

            } catch (err) {
                console.error(err);
                toast.error("Failed to parse Excel file.");
            } finally {
                setIsProcessingExcel(false);
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }
            }
        };
        reader.readAsBinaryString(file);
    };

    const transparentOption = {
        label: "Transparent",
        value: "transparent"
    }

    const handleDeletePoItem = (indexToDelete) => {
        const updatedList = PoListing.filter((_, index) => index !== indexToDelete);
        setPoListing(updatedList);
    };
    const ADD_NEW_VALUE = "__add_new__";

    const selectStyles = {
        option: (base, state) => {
            const isAddNew = state.data?.value === ADD_NEW_VALUE;

            return {
                ...base,
                color: isAddNew ? "#0d6efd" : base.color,
                fontWeight: isAddNew ? 600 : base.fontWeight,
                // optional: hover/focus background
                backgroundColor: state.isFocused
                    ? isAddNew
                        ? "#e7f1ff"
                        : base.backgroundColor
                    : base.backgroundColor,
            };
        },
        singleValue: (base, state) => {
            const isAddNew = state.data?.value === ADD_NEW_VALUE;
            return {
                ...base,
                color: isAddNew ? "#0d6efd" : base.color,
                fontWeight: isAddNew ? 600 : base.fontWeight,
            };
        },
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };
    const formatPrice = (price) => {
        const num = Number(price);
        if (isNaN(num)) return 'Rs 0.00';
        return `Rs ${num.toFixed(2)}`;
    };
    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, 'text-start')}>
                <div>
                    <div className={styles.Header}>
                        <Heading heading={'Add Purchase Order'} headingStyle={styles.Heading} />

                        <Select
                            options={skuOptions}
                            className={classNames(styles.SelectBox)}
                            classNamePrefix="custom-select"
                            isSearchable
                            filterOption={customFilter}
                            disabled={!values.brand}
                            placeholder="Search by SKU, Brand, Category, Model, Color..."
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            onChange={(selected) => {
                                const data = selected?.fullData;
                                if (!data) return;

                                setFieldValue("brand", {
                                    label: data.brand?.name,
                                    value: data.brand?.name,
                                    _id: data.brand?._id,
                                    ...data.brand,
                                });

                                // ✅ Fix naming here:
                                setFieldValue("competebleBrand", {
                                    label: data.compatiableBrand?.name,
                                    value: data.compatiableBrand?.name,
                                    _id: data.compatiableBrand?._id,
                                    ...data.compatiableBrand,
                                });

                                setFieldValue("model", {
                                    label: data.product?.name,
                                    value: data.product?.name,
                                    _id: data.product?._id,
                                    ...data.product,
                                });

                                setFieldValue("color", {
                                    label: data.color,
                                    value: data.color,
                                });

                                setFieldValue("ProductCategory", {
                                    label: data.product_category?.name,
                                    value: data.product_category?.name,
                                    _id: data.product_category?._id,
                                    ...data.product_category,
                                });

                                setFieldValue("SubCategory", {
                                    label: data.sub_category?.name,
                                    value: data.sub_category?.name,
                                    _id: data.sub_category?._id,
                                    ...data.sub_category,
                                });

                                setFieldValue("price", data.price || "");
                                setFieldValue("quantity", data.quantity || "");
                            }}

                        />


                    </div>
                    <div className={classNames(`${theme}ModalBackground`, styles.Body)}>
                        <div className={classNames(styles.TableFlex)}>
                            <div className={classNames(styles.InnerTableFlex)}>
                                <label className="LightFontColor Label style_InputLabel__lhse5">Brand</label>
                                <Select options={brandOptions}
                                    isSearchable
                                    isClearable
                                    value={values.brand}
                                    styles={selectStyles}
                                    menuPortalTarget={document.body}
                                    className={isEdits ? '' : classNames(styles.disable)} placeholder="Select Brand"
                                    onChange={async (item) => {
                                        if (item.value === "__add_new__") {
                                            setShowBrandModal(true);
                                            return;
                                        }
                                        if (item) {
                                            setFieldValue('brand', item); console.log(item, "itembrand");

                                        }
                                        else {
                                            await setFieldValue('brand', '');
                                        }
                                    }} />

                                <div className="Error"> {errors.brand && touched.brand ? errors.brand : ''}</div>
                            </div>
                            <div className={classNames(styles.InnerTableFlex)}>
                                <label className="LightFontColor Label style_InputLabel__lhse5">Competible Brand</label>
                                <Select
                                    options={listCompetebleBrndOptions}
                                    isSearchable
                                    isClearable
                                    value={values.competebleBrand}
                                    styles={selectStyles}
                                    menuPortalTarget={document.body}
                                    className={values.brand && isEdits ? '' : classNames(styles.disable)}
                                    placeholder="Select Competible Brand"
                                    onChange={async (item) => {
                                        if (item?.value === "__add_new__") {
                                            setShowCompatibleBrandModal(true);
                                            return;
                                        }
                                        if (item) {

                                            setFieldValue('competebleBrand', item);
                                            console.log(item, "competebleBrand");

                                            setModelList(listProduct?.filter((ii) => item._id === ii?.compatiableBrand?._id));
                                            setFieldValue('model', '');
                                        } else {
                                            await setFieldValue('competebleBrand', '');
                                            setFieldValue('model', '');
                                            setModelList([]);
                                        }
                                    }}
                                />
                                <div className="Error"> {errors.competebleBrand && touched.competebleBrand ? errors.competebleBrand : ''}</div>
                            </div>
                            <div className={classNames(styles.InnerTableFlex)}>
                                <label className="LightFontColor Label style_InputLabel__lhse5">Model </label>
                                <Select
                                    className={values.competebleBrand && isEdits ? '' : classNames(styles.disable)}
                                    options={ModelListOptions}
                                    isSearchable
                                    isClearable
                                    value={values.model}
                                    styles={selectStyles}
                                    menuPortalTarget={document.body}
                                    placeholder="Select Model"
                                    onChange={(item) => {
                                        if (item?.value === "__add_new__") {
                                            setShowModelModal(true);
                                            return;
                                        }
                                        setFieldValue('model', item);
                                    }}
                                />
                                <div className="Error"> {errors.model && touched.model ? errors.model : ''}</div>
                            </div>

                            <div className={classNames(styles.InnerTableFlex)}>
                                <label className="LightFontColor Label style_InputLabel__lhse5">Product Category </label>

                                <Select
                                    className={values.model && isEdits ? '' : classNames(styles.disable)}
                                    options={listCategoryOptions}
                                    isSearchable
                                    isClearable
                                    value={values.ProductCategory}
                                    styles={selectStyles}
                                    menuPortalTarget={document.body}
                                    placeholder={'Select Product Category'}
                                    onChange={async (item) => {
                                        if (item?.value === "__add_new__") {
                                            setShowCatModal(true);
                                            return;
                                        }
                                        if (item) {
                                            debugger
                                            setFieldValue('ProductCategory', item);
                                            setSubCatList(listSubCategory?.filter((ii) => item._id === ii?.category?._id));
                                            setFieldValue('SubCategory', '');
                                            if (item.label === "Screen Protector") {
                                                setFieldValue("color", transparentOption);

                                            }
                                        } else {
                                            await setFieldValue('ProductCategory', '');
                                            setFieldValue('SubCategory', '');
                                            setSubCatList([]);
                                        }
                                    }}
                                />
                                <div className="Error"> {errors.ProductCategory && touched.ProductCategory ? errors.ProductCategory : ''}</div>
                            </div>

                            <div className={classNames(styles.InnerTableFlex)}>
                                <label className="LightFontColor Label style_InputLabel__lhse5">Product Sub Category </label>
                                <Select
                                    className={values.ProductCategory && isEdits ? '' : classNames(styles.disable)}
                                    options={SubCatlListOptions}
                                    isSearchable
                                    isClearable
                                    value={values.SubCategory}
                                    styles={selectStyles}
                                    menuPortalTarget={document.body}
                                    placeholder={'Select Sub Category'}
                                    formatOptionLabel={(option) => (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <span style={{ marginRight: '8px' }}>{option.label}</span>
                                            {option.image && option.value !== "__add_new__" && (
                                                <img 
                                                    src={option.image} 
                                                    alt="" 
                                                    className={styles.dropdownImage}
                                                />
                                            )}
                                        </div>
                                    )}
                                    onChange={(item) => {
                                        if (item?.value === "__add_new__") {
                                            setShowSubCatModal(true);
                                            return;
                                        }
                                        setFieldValue('SubCategory', item);
                                    }}
                                />
                                <div className="Error"> {errors.SubCategory && touched.SubCategory ? errors.SubCategory : ''}</div>
                            </div>
                            <div className={classNames(styles.InnerTableFlex)}>
                                <label className="LightFontColor Label style_InputLabel__lhse5">Product Color <span className={classNames(styles.warn)}>{values.ProductCategory.label === "Screen Protector" && ` Not For This Category!`}</span></label>
                                <Select
                                    className={
                                        values.ProductCategory && isEdits ? '' : classNames(styles.disable)
                                    }
                                    options={colorarrayOptions}
                                    isSearchable
                                    isClearable
                                    value={values.ProductCategory.label === "Screen Protector" ? "Transparent" : values.color}

                                    placeholder="Select Color"
                                    styles={selectStyles}
                                    menuPortalTarget={document.body}

                                    isDisabled={values.ProductCategory.label === "Screen Protector"}   // 🔒 disable select

                                    onChange={(item) => {
                                        if (item?.value === "__add_new__") {
                                            setShowColorModal(true);
                                            return;
                                        }
                                        // Only update if NOT screen protector
                                        if (values.ProductCategory.label === "Screen Protector") {
                                            setFieldValue("color", transparentOption);

                                        }
                                        else {
                                            setFieldValue("color", item);

                                        }
                                    }}
                                />

                                <div className="Error"> {errors.color && touched.color ? errors.color : ''}</div>
                            </div>

                            {/* <div className={classNames(styles.InnerTableFlex)}>
                                <label className="LightFontColor Label style_InputLabel__lhse5">Please Select Currency</label>
                                
                                <Select
                                    className={values.SubCategory && isEdits ? '' : classNames(styles.disable)}
                                    options={[]}
                                    isSearchable
                                    isClearable
                                    value={values.currency}
                                    placeholder={'Select Currency'}
                                    onChange={(item) => {
                                        setFieldValue('currency', item[0]);
                                        
                                    }}
                                />
                                <div className="Error"> {errors.currency && touched.currency ? errors.currency : ''}</div>
                            </div> */}
                            <div className={classNames(styles.InnerTableFlex)}>
                                <CustomInput
                                    label={'Price'}
                                    type={'number'}
                                    placeholder={'e.g. 123'}
                                    value={values.price}
                                    onChange={handleChange('price')}
                                    CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle, `${values.SubCategory && isEdits ? '' : styles.disable}`)}
                                    CustomLabelStyle={styles.CustomLabelStyle}
                                    InputContainerStyle={styles.InputContainerStyle}
                                    error={errors.price && touched.price ? errors.price : ''}
                                />
                            </div>

                            <div className={classNames(styles.InnerTableFlex)}>
                                <CustomInput
                                    label={'Quantity'}
                                    placeholder={'123'}
                                    value={values.quantity}
                                    type={'number'}
                                    onChange={handleChange('quantity')}
                                    CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle, `${values.price && isEdits ? '' : styles.disable}`)}
                                    CustomLabelStyle={styles.CustomLabelStyle}
                                    InputContainerStyle={styles.InputContainerStyle}
                                    error={errors.quantity && touched.quantity ? errors.quantity : ''}
                                />
                            </div>
                            <div className={classNames(styles.InnerTableFlex)}>
                                <CustomInput
                                    label={'Description'}
                                    placeholder={'Type Something...'}
                                    value={values.description}
                                    onChange={handleChange('description')}
                                    CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle, `${values.quantity && isEdits ? '' : styles.disable}`)}
                                    CustomLabelStyle={styles.CustomLabelStyle}
                                    InputContainerStyle={styles.InputContainerStyle}
                                />
                            </div>
                            <label>Raw Images</label>
                            <UploadAvatarArray
                                setAvatarFileArray={setAvatarFileArray}
                                UploadedFile={avatarFile}
                                avatarFileArray={avatarFileArray}
                                setArray={uploadMediaArray}
                                setFile={setAvatarFile}
                                selectedImg={selectedImg}
                                setSelectedImg={setSelectedImg}
                            />
                            {uploading && (
                                <div className="mt-2 d-flex align-items-center">
                                    <div className="spinner-border text-primary me-2" role="status" />
                                    <span>Uploading... {uploadProgress}%</span>
                                </div>
                            )}
                        </div>
                        <AddBrand show={showBrandModal} datatable={listBrnd} handleClose={closeProductHandler} onSuccessAdd={(val) => handleSuccessAdd('brand', val)} />
                        <AddCompetibleBrand show={showCompatibleBrandModal} datacpmpatible={listCompetebleBrnd} handleClose={closeProductHandler} onSuccessAdd={(val) => handleSuccessAdd('competebleBrand', val)} />
                        <AddCategory show={showCatModal} datatable={listCategory} handleClose={closeProductHandler} onSuccessAdd={(val) => handleSuccessAdd('category', val)} />
                        <AddSubCategory show={showSubCatModal} datatable={listSubCategory} selectedCategory={values.ProductCategory} handleClose={closeProductHandler} onSuccessAdd={(val) => handleSuccessAdd('subCategory', val)} />
                        <AddColors show={showColorModal} datatable={colorlist} handleClose={closeProductHandler} onSuccessAdd={(val) => handleSuccessAdd('color', val)} />
                        <AddProduct show={showModelModal} datatable={listProduct} selectedCompatibleBrand={values.competebleBrand} handleClose={closeProductHandler} onSuccessAdd={(val) => handleSuccessAdd('model', val)} />

                        <div className={classNames(styles.ButtonContainer, 'd-flex justify-content-between align-items-center mb-3')}>
                            <CustomButton text={'Add PO'} containerStyle={styles.SubmitBtn} submitHandle={handleSubmit} />
                            
                            <div className="d-flex gap-3">
                                <button type="button" className="btn btn-outline-primary fw-bold" onClick={downloadSampleExcel}>
                                    Download Sample Format
                                </button>
                                
                                <input 
                                    type="file" 
                                    accept=".xlsx, .xls" 
                                    ref={fileInputRef} 
                                    style={{ display: 'none' }} 
                                    onChange={handleExcelUpload} 
                                />
                                <button type="button" className="btn btn-success fw-bold" onClick={() => fileInputRef.current?.click()}>
                                    Upload Excel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <InnerPoTable PoList={PoListing} OffPage={true} setIsEdit={setIsEdit} handleDelete={handleDeletePoItem} />

                {PoListing.length > 0 && (
                    <div className={classNames(styles.ButtonContainer, 'd-flex justify-content-start')}>
                        <CustomButton
                            text={'Add Supplier'}
                            containerStyle={styles.SubmitBtn}
                            submitHandle={() => {
                                if (isRestrictActions(screenEnum.po, screenActionEnum.create)) {
                                    setShowModal(!modalShow);
                                }
                            }}
                        />
                        <PurchaseOrderSuplierModal show={modalShow} handleClose={() => setShowModal(!modalShow)} SubmmitPo={SubmmitPo} setSupplierVal={setSupplierVal} />
                        {/* <AddBrand show={showBrandModal} handleClose={() => setShowBrandModal(false)} /> */}

                    </div>
                )}
            </div>
            {isProcessingExcel && <OverlayLoading />}
            {POLoading && <OverlayLoading />}
        </DashboardWrapper>
    );
}
